import { render, staticRenderFns } from "./ContainerHub.vue?vue&type=template&id=4e49b884&"
import script from "./ContainerHub.vue?vue&type=script&lang=js&"
export * from "./ContainerHub.vue?vue&type=script&lang=js&"
import style0 from "./ContainerHub.vue?vue&type=style&index=0&id=4e49b884&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports